import React, {useState} from "react";
import {styled} from "@reside/ui";

import {CommitWithResults} from "../types";

const BannerContainer = styled.div`
  background-color: #fff5f5;
  border-left: 4px solid #ff3a45;
  padding: 16px 20px;
  margin-bottom: 24px;
  border-radius: 4px;
`;

const BannerHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ErrorCount = styled.span`
  font-weight: 600;
  color: #a10009;
  font-size: 14px;
`;

const ToggleButton = styled.button`
  background: none;
  border: none;
  color: #a10009;
  cursor: pointer;
  font-size: 12px;
  text-decoration: underline;
  padding: 0;
`;

const ErrorList = styled.ul`
  margin: 8px 0 0;
  padding-left: 20px;
  font-size: 13px;
  color: #596973;
`;

function collectErrors(commit: CommitWithResults): string[] {
  const errors: string[] = [];
  for (const result of commit.template_results) {
    if (result.errors) {
      errors.push(...result.errors);
    }
  }
  return errors;
}

export const ErrorSummaryBanner = ({
  latestCommit,
}: {
  latestCommit: CommitWithResults;
}): JSX.Element | null => {
  const [expanded, setExpanded] = useState(false);
  const errors = collectErrors(latestCommit);

  if (errors.length === 0) return null;

  const previewErrors = errors.slice(0, 3);
  const hasMore = errors.length > 3;

  return (
    <BannerContainer>
      <BannerHeader>
        <ErrorCount>
          {errors.length} error{errors.length !== 1 ? "s" : ""} in latest commit
        </ErrorCount>
        {hasMore && (
          <ToggleButton onClick={() => setExpanded(!expanded)}>
            {expanded ? "Show less" : `Show all ${errors.length}`}
          </ToggleButton>
        )}
      </BannerHeader>
      <ErrorList>
        {(expanded ? errors : previewErrors).map((error, i) => (
          // skipcq: JS-0437 -- index needed: error strings can be duplicates
          <li key={`${error}-${i}`}>{error}</li>
        ))}
      </ErrorList>
    </BannerContainer>
  );
};
